import React, { Fragment } from "react";
import { ExternalDocument } from "../../core/api/model";
import { DashboardDocumentsListItem, DashboardDocumentsListEmpty } from ".";

export interface DashboardDocumentsListProps {
  documents: ExternalDocument[];
}

export const DashboardDocumentsList = (props: DashboardDocumentsListProps) => {
  return props.documents.length > 0 ? (
    // list
    <Fragment>
      {props.documents
      .map((document: ExternalDocument) => 
        <DashboardDocumentsListItem key={document.id} document={document} />
      )}
    </Fragment>
  ) :
  // empty
  <DashboardDocumentsListEmpty />;
};
